import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import Button from '@/components/Button';
import { IReqLabels } from '@/types/parcel/orders/labels.interface';

import Modal from '../Modal';

interface DownloadModalProps {
  isOpen: boolean;
  onClose: () => void;
  trackingIds: string[];
  downloadLabels: ({ pageSize, trackingIds }: IReqLabels) => void;
  amount?: boolean; // true = 1 label / false = +1 label
}

const DownloadModal = ({
  isOpen,
  onClose,
  trackingIds,
  downloadLabels,
  amount,
}: DownloadModalProps) => {
  const theme = useTheme();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Descargar etiqueta${amount ? '' : 's'}`}
      actions={
        <Box
          sx={{
            display: 'flex',
            gap: '1rem',
            justifyContent: 'space-evenly',
            width: '100%',
            paddingBottom: '1rem',
          }}
        >
          <Button onClick={() => downloadLabels({ pageSize: 'letter', trackingIds: trackingIds })}>
            Carta
          </Button>
          <Button
            variant="contained"
            onClick={() => downloadLabels({ pageSize: 'small', trackingIds: trackingIds })}
          >
            Small
          </Button>
          <Button
            variant="contained"
            onClick={() => downloadLabels({ pageSize: 'zebra', trackingIds: trackingIds })}
          >
            Zebra
          </Button>
        </Box>
      }
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem', alignItems: 'center' }}>
        <CloudDownloadOutlinedIcon sx={{ width: '50px', height: 'auto' }} color="primary" />
        <Typography
          sx={{ color: theme.palette.secondary.main, fontWeight: 'bold', textAlign: 'center' }}
        >
          Selecciona el tamaño que deseas imprimir
        </Typography>
      </Box>
    </Modal>
  );
};

export default DownloadModal;
